<template>
    <v-footer class="d-flex justify-center"        color="blue-grey darken-2"  dark app v-if="sessonStore.isLogin">
      土マッチングシステム
    </v-footer>
</template>
<script setup>
import { useSessonStore } from "@/stores/common";
const sessonStore = useSessonStore();
</script>
